import React from 'react';
import { connect } from 'react-redux'

import {
	getCurrentAccount,
	getCurrentUser,
	getAccountUsers
} from 'state/selectors'

import {
	openTeamChat,
	updateTeamOrder
} from 'state/actions'

import {
	isMobile
} from 'utils'

import TeamItem from './team-item'
import TeamGroup from './team-group'

import ListContainer from 'components/list-container/list-container'

import { MainContext } from 'context'

const TeamRoute = props => {
    const {
        userIds,
        teamList,
        type,
        allUsers,
        canEditTeam,
        deleteTeam,
        editTeam,
        openTeamChat,
        searchTerm,
        amAdmin,
        userData,
        accountData,
        toggleState,
        path,
        isMini,
        isPremium,
        shouldBlockTransition,
        accountUsers,
        updateTeamOrder
    } = props

    let emptyTitle
    let emptyCopy
    let list = []

    switch(type){
        case 'team':
            emptyTitle = "No teams."
            emptyCopy = "Create a team to track progress and assign access rights."

            list = [
                ...teamList
            ]
            break
        case 'people':
        case 'guests':
        case 'stakeholders':
            emptyTitle = "No guest accounts."
            emptyCopy = "When you invite guests to your external projects, they'll show up here."

            const userList = props.userList ? props.userList : userIds.map(userId => {
                return allUsers[userId]
            })

            const inviteList = props.inviteList ? props.inviteList : []

            list = [
                ...userList,
            ]

            inviteList.forEach(invite => {
                if(!userList.find(user => {
                    return (user.email && user.email.toLowerCase() == invite.recipient_email.toLowerCase())
                })){
                    list.push(invite)
                }
            })

            if(type == 'stakeholder'){
                const {
                    roles
                } = this.context

                let tempList = []

                list.forEach(item => {
                    if(roles.admin || !item.is_private){
                        tempList.push(item)
                    }
                })

                list = tempList
            }

            break
    }


    let listHeadingColumns = [
        {
            label: 'Name',
            slug: 'name',
            getter: object => {
                return object.first_name ? object.first_name : 'zzz'
            }
        },{
            label: 'Email',
            slug: 'email',
            getter: object => {
                return object.email ? object.email : object.recipient_email
            }
        },{
            label: 'Role',
            slug: 'role',
            getter: object => {
                let role = (object.roles && object.roles[accountData.id]) ? object.roles[accountData.id] : object.role

                return role ? role : 'zzz'
            }
        }
    ]

    if(type == 'stakeholders'){
        listHeadingColumns = [
            {
                label: 'Name',
                slug: 'name',
                getter: object => {
                    return object.first_name ? object.first_name : 'zzz'
                }
            },{
                label: 'Organisation',
                slug: 'organisation',
                getter: object => {
                    return object.organisation ? object.organisation : 'zzz'
                }
            },{
                label: 'Email',
                slug: 'email',
                getter: object => {
                    return object.email ? object.email : object.recipient_email
                }
            },{
                label: 'Phone',
                slug: 'phone',
                getter: object => {
                    return object.phone ? object.phone : 'zzz'
                }
            }
        ]

        emptyTitle = `No stakeholders`
        emptyCopy = `Add a stakeholder to get started.`
    }

    let unit = null
    let unitProps = null

    if(type == 'team'){
        unit = TeamGroup
        unitProps = {
            allUsers,
            accountUsers,
            editTeam,
            deleteTeam,
            canEditTeam,
            openTeamChat,
            isMini,
        }
    }else{
        unit = TeamItem

        unitProps = {
            isGuest: type == 'guests',
            amAdmin: amAdmin,
            userData: userData,
            currentAccount: accountData,
            type,
            path,
            isPremium,
            isStakeholder: type == 'stakeholders',
        }

    }

    return (
        <ListContainer
            items={list}
            unit={unit}
            unitProps={unitProps}
            emptyTitle={emptyTitle}
            emptyCopy={emptyCopy}
            type={type}
            isGrid={!toggleState && type !== 'stakeholders' && !isMobile()}
            canSort={type !== 'team'}
            shouldBlockTransition={shouldBlockTransition}
            columns={listHeadingColumns}
            searchTerm={searchTerm}
            updateTeamOrder={updateTeamOrder}
        />
    )
};

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
		allUsers: state.account.entities.users,
		accountUsers: getAccountUsers(state)
	}
}

export default connect(mapStateToProps, { 
	openTeamChat,
	updateTeamOrder
})(TeamRoute)

TeamRoute.contextType = MainContext